<template>
  <div class="audio-content" v-loading="loading">
    <el-button
      type="primary"
      @click="openEditWin('create')"
      >添加</el-button
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="name" label="屏幕名称"> </el-table-column>
      <el-table-column prop="number" label="屏幕编号"> </el-table-column>
      <el-table-column prop="lamp_name" label="所属路灯"> </el-table-column>
      <el-table-column prop="ste" label="屏幕状态">
        <template slot-scope="scope">
          <i :class="steColorType[scope.row.ste]"></i>
          <span>{{ steType[scope.row.ste] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="pattern" label="设备模式">
        <template slot-scope="scope">
          <span>{{ patternType[scope.row.pattern] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="screen_type" label="屏幕类别">
        <template slot-scope="scope">
          <span>{{ screenType[scope.row.screen_type] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="添加时间">
        <template slot-scope="scope">
          <span>{{ $commonJs.formatDate(parseInt(scope.row.created_at)*1000) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加' : '修改'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="100px"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item label="屏幕名称" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
          <el-form-item label="屏幕编号" prop="number">
            <el-input v-model="editOne.number"></el-input>
          </el-form-item>
   
          <el-form-item label="选择路灯">
            <el-select
              clearable
              filterable 
              placeholder="请选择所属路灯"
              v-model="editOne.lamp_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in lampList"
                :key="t.lamp_id"
                :label="t.name"
                :value="t.lamp_id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="屏幕类别" prop="screen_type" v-if="editType === 'create'">
            <el-select
              placeholder="请选择屏幕类别"
              v-model="editOne.screen_type"
              style="width: 100%"
            >
              <el-option label="卡莱特" :value="0"></el-option>
              <el-option label="仰邦" :value="1"></el-option>
              <el-option label="熙讯" :value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="设备模式" prop="pattern">
            <el-select
              placeholder="请选择设备模式"
              v-model="editOne.pattern"
              style="width: 100%"
            >
              <el-option label="公网" :value="0"></el-option>
              <el-option label="内网" :value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="设备地址" prop="device_address" v-if="editOne.pattern">
            <el-input v-model="editOne.device_address"></el-input>
          </el-form-item>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import lightListApi from "@/api/light/lightList"
import screenApi from "@/api/message/screenList"
export default {
  data() {
    return {
      steType: ["离线", "在线"],
      steColorType: ["valuered", "valuegreen"],
      patternType: ["公网", "内网"],
      screenType: ["卡莱特", "仰邦", "熙讯"],
      loading: false,
      dialogVisible: false,
      lampList: [],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      editType: -1,
      devSelect: [],
      editOne: {
        name: '',
        number: '',
        lamp_id: '',
        screen_type: '',
        pattern: '',
        device_address: '',
      },
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      screenApi.screenList(this.pageInfo).then((res) => {
        console.log('screenList',res)
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.getLampList()
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: '',
          number: '',
          lamp_id: '',
          screen_type: '',
          pattern: '',
          device_address: '',
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          number: index.number,
          lamp_id: index.lamp_id,
          screen_type: index.screen_type,
          pattern: index.pattern,
          device_address: index.device_address
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      screenApi.screenEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      screenApi.screenAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getLampList() { // 获取灯组列表
      lightListApi.lightList({
        // lamp_protocol: 3,
        page: 1,
        pageSize: 200,
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.lampList = resData.list;
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          screenApi.screenDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  }
};
</script>
<style lang='less' scoped>
.audio-content {
  width: 100%;
}
.map-container {
  padding-left: 100px;
  height: 180px;
  margin-bottom: 10px;
}
</style> 